<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Beneficiario na parte cadastro de Status do Menu Beneficiario  ==================------->

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Nome')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Nome')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>Situação</span>
          <v-select
            :append-to-body="id == null ? false : true"
            :options="situacoes"
            name="Situação"
            id="Situação"
            v-model="formCadastro.situacao"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Situação'
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Situação'
              )
            "
          ></v-select>
        </div>
        <div v-if="tipo == 'Beneficiario'" class="vx-col sm:w-1/2 w-full">
          <span>Dia de Faturamento</span>
          <vs-input
            class="w-full"
            name="Dia de Faturamento"
            id="Dia de Faturamento"
            v-model="formCadastro.diaFaturamento"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div v-else class="vx-col sm:w-1/2 w-full">
          <span>Parentesco</span>
          <v-select
            :append-to-body="id == null ? false : true"
            :options="parentesco"
            name="Parentesco"
            id="Parentesco"
            v-model="formCadastro.idParentesco"
            label="label"
            :reduce="(parentesco) => parentesco.id"
            :key="formCadastro.idParentesco"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Parentesco'
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Parentesco'
              )
            "
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>CPF</span>
          <vs-input
            class="w-full"
            name="CPF"
            id="CPF"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'CPF')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'CPF')
            "
            v-model="formCadastro.cpf"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'###.###.###-##'"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>RG</span>
          <vs-input
            class="w-full"
            name="RG"
            id="RG"
            v-validate="{ required: true, min: 6 }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'RG')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'RG')
            "
            v-model="formCadastro.rg"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>Nome Da Mãe</span>
          <vs-input
            class="w-full"
            name="Nome Da Mãe"
            id="Nome Da Mãe"
            v-model="formCadastro.nomeDaMae"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true, min: 6 }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Da Mãe'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Da Mãe'
              )
            "
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Nome Do Pai</span>
          <vs-input
            class="w-full"
            name="Nome Do Pai"
            id="Nome Do Pai"
            v-model="formCadastro.nomeDoPai"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true, min: 6 }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Do Pai'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Do Pai'
              )
            "
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>CNH</span>
          <vs-input
            class="w-full"
            name="CNH"
            id="CNH"
            type="number"
            v-model="formCadastro.cnh"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Data de Vencimento Cnh</span>
          <vs-input
            class="w-full"
            name="Data de Vencimento Cnh"
            id="Data de Vencimento Cnh"
            v-model="formCadastro.dataVencimentoCnh"
            v-validate="{ date_format: 'dd/MM/yyyy' }"
            val-icon-danger="clear"
            v-mask="'##/##/####'"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-calendar"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Sexo</span>
          <v-select
            :options="sexo"
            name="Sexo"
            id="Sexo"
            v-model="formCadastro.sexo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Sexo')
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Sexo'
              )
            "
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <span>Escolaridade</span>
          <v-select
            :options="escolaridade"
            name="Escolaridade"
            id="Escolaridade"
            v-model="formCadastro.escolaridade"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <span>Estado Civil</span>
          <v-select
            :options="estadoCivil"
            name="Estado Civil"
            id="Estado Civil"
            v-model="formCadastro.estadoCivil"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Estado Civil'
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Estado Civil'
              )
            "
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>Email</span>
          <vs-input
            type="email"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.email"
            v-validate="{ required: true, email: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Email')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Email')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Data de Nascimento</span>
          <vs-input
            class="w-full"
            name="Data de Nascimento"
            id="Data de Nascimento"
            v-model="formCadastro.dataNascimento"
            val-icon-danger="clear"
            v-mask="'##/##/####'"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-calendar"
            icon-no-border
            v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Data de Nascimento'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Data de Nascimento'
              )
            "
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>Celular</span>
          <vs-input
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celular"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Celular')
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Celular'
              )
            "
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Telefone</span>
          <vs-input
            class="w-full"
            name="Telefone"
            id="Telefone"
            v-model="formCadastro.telefone"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) ####-####'"
          />
        </div>
      </div>

      <!-----============================ OBS: Precisamos integrar com os correios para que quando jogar o CEP ele venha com o RUA, CIDADE, ESTADO E PAÍS  ==================------->

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>CEP</span>
          <vs-input
            class="w-full"
            name="Cep"
            id="Cep"
            @keyup.native="keymonitor"
            v-model="formCadastro.cep"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'##.###-###'"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Cep')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Cep')
            "
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Endereço</span>
          <vs-input
            class="w-full"
            name="Endereço"
            id="Endereço"
            v-model="formCadastro.endereco"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Endereço'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Endereço'
              )
            "
          />
        </div>
      </div>

      <!-----============================ OBS: API CORREIOS  ==================------->
      <div class="vx-row mb-4"></div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Número</span>
          <vs-input
            class="w-full"
            name="Numero"
            id="Numero"
            v-model="formCadastro.numero"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Número')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Número')
            "
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <span>Complemento</span>
          <vs-input
            class="w-full"
            name="Complemento"
            id="Complemento"
            v-model="formCadastro.complemento"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <span>Bairro</span>
          <vs-input
            class="w-full"
            name="Bairro"
            id="Bairro"
            v-model="formCadastro.bairro"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Bairro')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Bairro')
            "
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <span>Estado</span>
          <vs-input
            class="w-full"
            name="Estado"
            id="Estado"
            v-model="formCadastro.estado"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Estado')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Estado')
            "
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <span>Cidade</span>
          <vs-input
            class="w-full"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Cidade')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Cidade')
            "
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            variant="success"
            :edit="id == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import cpfCnpj from "../../services/cpfCnpj";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";
import dataFunctions from "./../../utils/dateConversion";
import utilsList from "./../../utils/list";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    tipo: {
      type: String,
    },
    id: {
      type: Number,
    },
    form: {
      type: String,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      aguardeCadastro: false,
      parentesco: [],
      clientes: [],
      situacoes: ["ATIVO", "INATIVO"],
      sexo: ["Masculino", "Feminino", "Outros"],
      escolaridade: [
        "Ensino Fundamental",
        "Ensino Médio",
        "Ensino Superior",
        "Pós Graduação",
      ],
      estadoCivil: ["Solteiro", "Casado", "Divorciado", "Viúvo"],
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        id: null,
        nome: null,
        cpf: null,
        rg: null,
        nomeDaMae: null,
        nomeDoPai: null,
        cnh: null,
        dataVencimentoCnh: null,
        sexo: null,
        escolaridade: null,
        estadoCivil: null,
        email: null,
        telefone: null,
        celular: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        bairro: null,
        complemento: null,
        estado: null,
        cidade: null,
        pais: null,
        diaFaturamento: null,
        situacao: null,
        idParentesco: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.id) {
        this.formCadastro.id = this.id;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.cpf = this.dados.cpf;
        this.formCadastro.rg = this.dados.rg;
        this.formCadastro.nomeDaMae = this.dados.nomeDaMae;
        this.formCadastro.nomeDoPai = this.dados.nomeDoPai;
        this.formCadastro.cnh = this.dados.CNH;
        this.formCadastro.dataVencimentoCnh = this.dados.dataVencimentoCNH
          ? dataFunctions.converteISOToDate(this.dados.dataVencimentoCNH)
          : null;
        this.formCadastro.sexo = this.dados.sexo;
        this.formCadastro.escolaridade = this.dados.escolaridade;
        this.formCadastro.estadoCivil = this.dados.estadoCivil;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.dataNascimento = this.dados.dataNascimento
          ? dataFunctions.converteISOToDate(this.dados.dataNascimento)
          : null;
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.pais = this.dados.pais;
        this.formCadastro.diaFaturamento = this.dados.diaFaturamento;
        this.formCadastro.situacao = this.dados.situacao;
        this.formCadastro.idParentesco = this.dados.id_parentesco;
      } else {
        console.log(this.tipo);
        this.resetForm();
      }
    },
    onSubmit() {
      var objSend = { ...this.formCadastro };
      var action = objSend.id ? `Atualizar/${objSend.id}` : "Adicionar";
      var metodo = objSend.id ? "put" : "post";

      if (this.tipo == "Beneficiario") {
        objSend.idBeneficiario = this.id;
      } else {
        objSend.idDependente = this.id;
      }

      if (objSend.dataNascimento)
        objSend.dataNascimento = dataFunctions.convertDateToISO(
          objSend.dataNascimento
        );
      if (objSend.dataVencimentoCnh)
        objSend.dataVencimentoCnh = dataFunctions.convertDateToISO(
          objSend.dataVencimentoCnh
        );

      console.log(objSend);

      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: `Este Cpf não é válido`,
          color: "danger",
        });
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("concluido", objSend);
        }
      });
    },

    keymonitor: function (event) {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace(".", "").replace("-", "");
        service
          .post("g", "BuscaCEP", {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Não Foi possível encontrar o cep",
              color: "danger",
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        id: null,
        nome: null,
        cpf: null,
        rg: null,
        nomeDaMae: null,
        nomeDoPai: null,
        cnh: null,
        dataVencimentoCnh: null,
        sexo: null,
        escolaridade: null,
        estadoCivil: null,
        email: null,
        telefone: null,
        celular: null,
        dataNascimento: null,
        cep: null,
        endereco: null,
        numero: null,
        bairro: null,
        complemento: null,
        estado: null,
        cidade: null,
        pais: null,
        diaFaturamento: null,
        situacao: null,
        idParentesco: null,
        idCliente: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit("cancel");
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  mounted() {
    this.preencheForm();
    this.buscaDadosSelects(
      "domParentesco",
      "parentesco",
      "nomeParentesco",
      "idParentesco"
    );
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
